const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Common timezone options
export const TIMEZONE_OPTIONS = [
  { value: "Indian/Maldives", label: "Maldives (GMT+5)", offset: 5 },
  { value: "Asia/Kolkata", label: "India (GMT+5:30)", offset: 5.5 },
  { value: "Asia/Dhaka", label: "Bangladesh / Dhaka (GMT+6)", offset: 6 },
  { value: "Asia/Singapore", label: "Singapore (GMT+8)", offset: 8 },
  { value: "Asia/Dubai", label: "Dubai (GMT+4)", offset: 4 },
  { value: "Asia/Tokyo", label: "Japan (GMT+9)", offset: 9 },
  { value: "Europe/London", label: "London (GMT+0)", offset: 0 },
  { value: "America/New_York", label: "New York (GMT-5)", offset: -5 },
  { value: "Pacific/Auckland", label: "Auckland (GMT+12)", offset: 12 },
  { value: "GMT-12", label: "GMT-12", offset: -12 },
  { value: "GMT-11", label: "GMT-11", offset: -11 },
  { value: "GMT-10", label: "GMT-10", offset: -10 },
  { value: "GMT-9", label: "GMT-9", offset: -9 },
  { value: "GMT-8", label: "GMT-8", offset: -8 },
  { value: "GMT-7", label: "GMT-7", offset: -7 },
  { value: "GMT-6", label: "GMT-6", offset: -6 },
  { value: "GMT-5", label: "GMT-5", offset: -5 },
  { value: "GMT-4", label: "GMT-4", offset: -4 },
  { value: "GMT-3", label: "GMT-3", offset: -3 },
  { value: "GMT-2", label: "GMT-2", offset: -2 },
  { value: "GMT-1", label: "GMT-1", offset: -1 },
  { value: "GMT+0", label: "GMT+0", offset: 0 },
  { value: "GMT+1", label: "GMT+1", offset: 1 },
  { value: "GMT+2", label: "GMT+2", offset: 2 },
  { value: "GMT+3", label: "GMT+3", offset: 3 },
  { value: "GMT+4", label: "GMT+4", offset: 4 },
  { value: "GMT+5", label: "GMT+5", offset: 5 },
  { value: "GMT+6", label: "GMT+6", offset: 6 },
  { value: "GMT+7", label: "GMT+7", offset: 7 },
  { value: "GMT+8", label: "GMT+8", offset: 8 },
  { value: "GMT+9", label: "GMT+9", offset: 9 },
  { value: "GMT+10", label: "GMT+10", offset: 10 },
  { value: "GMT+11", label: "GMT+11", offset: 11 },
  { value: "GMT+12", label: "GMT+12", offset: 12 },
];

// Format a UTC date string to the configured timezone
export function formatToTimezone(utcDateStr, tz) {
  if (!utcDateStr) return "—";
  try {
    const date = new Date(utcDateStr);
    if (isNaN(date.getTime())) return utcDateStr;

    // Handle GMT offset timezones like "GMT+6"
    const gmtMatch = tz?.match(/^GMT([+-]\d+)$/);
    if (gmtMatch) {
      const offsetHours = parseInt(gmtMatch[1]);
      const utcMs = date.getTime();
      const localMs = utcMs + offsetHours * 3600000;
      const local = new Date(localMs);
      return local.toISOString().replace("T", " ").substring(0, 19);
    }

    // Use Intl.DateTimeFormat for named timezones
    return new Intl.DateTimeFormat("en-GB", {
      timeZone: tz || "Asia/Dhaka",
      year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit", second: "2-digit",
      hour12: false
    }).format(date);
  } catch {
    return new Date(utcDateStr).toLocaleString();
  }
}

// Get current time in a timezone
export function getCurrentTimeInTz(tz) {
  try {
    const gmtMatch = tz?.match(/^GMT([+-]\d+)$/);
    if (gmtMatch) {
      const offsetHours = parseInt(gmtMatch[1]);
      const now = new Date();
      const utcMs = now.getTime() + now.getTimezoneOffset() * 60000;
      const local = new Date(utcMs + offsetHours * 3600000);
      return local.toISOString().replace("T", " ").substring(0, 19);
    }

    return new Intl.DateTimeFormat("en-GB", {
      timeZone: tz || "Asia/Dhaka",
      year: "numeric", month: "2-digit", day: "2-digit",
      hour: "2-digit", minute: "2-digit", second: "2-digit",
      hour12: false
    }).format(new Date());
  } catch {
    return new Date().toLocaleString();
  }
}

// Cache for settings - fetched once per session
let cachedTimezone = null;

export async function getTimezone() {
  if (cachedTimezone) return cachedTimezone;
  try {
    const token = localStorage.getItem("token");
    const res = await fetch(`${API}/settings`, { headers: { Authorization: `Bearer ${token}` } });
    const data = await res.json();
    cachedTimezone = data.timezone || "Asia/Dhaka";
    return cachedTimezone;
  } catch {
    return "Asia/Dhaka";
  }
}

export function clearTimezoneCache() {
  cachedTimezone = null;
}
